import React from 'react'

export default function Soportes() {
  return (
    <div>
      Soportes
    </div>
  )
}
